const config = {
  API_BASE_URL:          'https://api.countorasys.com/api',
  API_ORIGIN:            'https://api.countorasys.com',
  CHAT_HUB_URL:          'https://api.countorasys.com/hubs/chat',
  NOTIFICATIONS_HUB_URL: 'https://api.countorasys.com/hubs/notifications',
};

export default config;
